import styled from "styled-components";

export default styled.div`
  padding-bottom: 20px;
  padding-left: 1rem;
  padding-right: 1rem;

  @media screen and (max-width: 768px) {
    padding-bottom: 10px;
  }
`;
